import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { VIEW_LAYOUT, PATH_DELIMITER } from './consts';
import { StepsContext } from './steps-context';
import { StepGroupView } from './step-group-view';

export class StepContainer extends React.PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
    ]).isRequired,
    currentPath: PropTypes.string,
    layout: PropTypes.oneOf(_.values(VIEW_LAYOUT)),
  };

  static defaultProps = {
    currentPath: undefined,
    layout: undefined,
  };

  getRelativePath = (fullPath, parentPath) => {
    if (!parentPath) {
      return fullPath.split(PATH_DELIMITER)[0];
    }

    const relativePath = fullPath.replace(`${parentPath}.`, '');
    const scopedPath = relativePath.split(PATH_DELIMITER)[0];

    return `${parentPath}${PATH_DELIMITER}${scopedPath}`;
  }

  renderGroup = (context) => {
    const fullPath = this.props.currentPath || context.fullPath;
    const parentPath = this.props.currentPath ?
      '' :
      context.parentPath;
    if (!fullPath) {
      throw new Error('currentPath is required as either a prop or through a context provider');
    }

    const layout = this.props.layout || context.layout;
    if (!layout) {
      throw new Error('layout is required as either a prop or through a context provider');
    }

    return (
      <div className={classNames('step-container', layout)}>
        <StepGroupView
          relativePath={this.getRelativePath(fullPath, parentPath)}
          parentPath={parentPath}
          fullPath={fullPath}
          layout={layout}
        >
          {this.props.children}
        </StepGroupView>
      </div>
    );
  };

  render() {
    return (
      <StepsContext.Consumer>
        {this.renderGroup}
      </StepsContext.Consumer>
    );
  }
}
